module.exports = __webpack_public_path__ + "assets/38ffc8b745962b961dc35eec75944ea3.mp3";